
import { useState } from 'react';
import * as XLSX from 'xlsx';

/* import { Model } from '../models/model';
 */

export function useImportPpto() {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [resultado, setResultado] = useState(null);

    const reset = () => {
        setError(null);
        setResultado(null);
    };

    const downloadItemTemplate = () => {

        // Definimos la estructura base
        const data = [
            {
                "Item": "Obras provisionales",
                "Unidad": "",
                "Cantidad": 0,
                "Precio Unitario": 0,
                "Costo Unitario": 0
            },
            {
                "Item": "Transporte de Materiales equipos y Herramientas",
                "Unidad": "GLB",
                "Cantidad": 1,
                "Precio Unitario": 1500.00,
                "Costo Unitario": 400.00
            }
        ];

        // Creamos la hoja de trabajo
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla Importación");

        // Descargamos el archivo
        XLSX.writeFile(workbook, "plantilla_importacion_items.xlsx");
    };

    const downloadTemplatePpto = () => {

        const data = [
            ["Referencia:", "Construccion casa playa"],
            ["Cliente:", "jose mendez ltda"],
            ["Contacto:", "pepe lopez"],
            ["Moneda:", "SOLES", "(opciones: SOLES, USD)"],
            ["Tipo Cambio:", 3.5, "(si es en USD)"],
            ["Fecha:", new Date().toLocaleDateString()],
            ["Area MT2", 100.35],

            [],

            ["Items del presupuesto:"],
            ["Categoria", "Nombre", "Unidad", "Cantidad", "Precio Unitario", "Costo Unitario"],

            ["Obras", "Transporte", "glb", 2, 1000, 700],
            ["Obras", "Acarreo", "glb", 2, 200, 120],
            ["Obras", "Materiales", "glb", 150, 0, 120],
            ["Obras", "Residente", "glb", 2, 1000, 800],

            ["Electricidad", "Instalación y conexión", "glb", 0, 0, 0],
            ["Electricidad", "Tablero", "glb", 2, 300, 0],
            ["Electricidad", "Empalme", "glb", 2, 150, 0],
            ["Electricidad", "Cable alimentador", "ml", 40, 25, 0],
        ];

        // Creamos la hoja de trabajo
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // Creamos el workbook
        const workbook = XLSX.utils.book_new();

        // Creamos la hoja de trabajo
        // const worksheet = XLSX.utils.json_to_sheet(data);
        // const workbook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla Importación");

        // Agregamos la hoja
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Plantilla Importación"
        );

        // Descargamos el archivo
        XLSX.writeFile(workbook, "excel_importacion_ppto.xlsx");
    };

    const handleImportarExcel = async (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {

            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const itemsCargados = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                    const itemsParaEnviar = itemsCargados.map(row => ({
                        descripcion: row['Descripción'] || row['Item'],
                        unidad: row['Unidad'] || null,
                        cantidad: Number(row['Cantidad']) || null,
                        precio_unitario: Number(row['Precio Unitario']) || null,
                        costo_unitario: Number(row['Costo Unitario']) || null
                    })).filter(item => item.descripcion);

                    resolve(itemsParaEnviar);

                } catch (error) {
                    reject(error);
                }
            };

            reader.readAsArrayBuffer(file);

            reader.onerror = (error) => {
                reject(error);
            };

        });

    };

    /* const handleImportarExcelPpto = async (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {

            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const itemsCargados = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                    console.log({ itemsCargados })

                    const itemsParaEnviar = itemsCargados.map(row => ({
                        descripcion: row['Descripción'] || row['Item'],
                        unidad: row['Unidad'] || null,
                        cantidad: Number(row['Cantidad']) || null,
                        precio_unitario: Number(row['Precio Unitario']) || null,
                        costo_unitario: Number(row['Costo Unitario']) || null
                    })).filter(item => item.descripcion);

                    resolve(itemsParaEnviar);

                } catch (error) {
                    reject(error);
                }
            };

            reader.readAsArrayBuffer(file);

            reader.onerror = (error) => {
                reject(error);
            };

        });

    };
 */

    const handleImportarExcelPpto = async (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {

            reader.onload = (e) => {
                try {

                    const data = new Uint8Array(e.target.result);

                    const workbook = XLSX.read(data, {
                        type: "array"
                    });

                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                    const rows = XLSX.utils.sheet_to_json(worksheet, {
                        header: 1,
                        defval: null
                    });

                    // -----------------------------------
                    // BUSCAR ENCABEZADO DE ITEMS
                    // -----------------------------------

                    const headerIndex = rows.findIndex(row =>
                        row?.[0] === "Categoria" &&
                        row?.[1] === "Nombre" &&
                        row?.[2] === "Unidad"
                    );

                    if (headerIndex === -1) {
                        console.error("No se encontró el encabezado de los items.");
                        return;
                    }

                    // -----------------------------------
                    // CABECERA
                    // -----------------------------------

                    const presupuesto = {
                        referencia: rows[0]?.[1] || "",
                        cliente: rows[1]?.[1] || "",
                        contacto: rows[2]?.[1] || "",
                        moneda: rows[3]?.[1] || "",
                        tipo_cambio: Number(rows[4]?.[1]) || 0,
                        fecha: rows[5]?.[1] || "",
                        area_mt2: Number(rows[6]?.[1]) || 0,
                        items: []
                    };

                    // -----------------------------------
                    // ITEMS
                    // -----------------------------------

                    for (let i = headerIndex + 1; i < rows.length; i++) {

                        const row = rows[i];

                        if (!row || row.every(value => value === null || value === "")) {
                            continue;
                        }

                        // Si no tiene nombre, no es un item válido
                        if (!row[1]) {
                            continue;
                        }

                        presupuesto.items.push({
                            categoria: row[0] || "",
                            nombre: row[1] || "",
                            unidad: row[2] || "",
                            cantidad: Number(row[3]) || 0,
                            precio_unitario: Number(row[4]) || 0,
                            costo_unitario: Number(row[5]) || 0
                        });
                    }

                    // return presupuesto;
                    resolve(presupuesto);

                } catch (error) {
                    reject(error);
                }
            };

            reader.readAsArrayBuffer(file);

            reader.onerror = (error) => {
                reject(error);
            };

        });

    };

    return {
        loading,
        error,
        resultado,
        setLoading,
        reset,
        downloadItemTemplate,
        handleImportarExcel,

        downloadTemplatePpto,
        handleImportarExcelPpto
    };
}